import { IntlShape, MessageFormatElement, createIntl } from 'react-intl'
import enUSMessages from '../../strings/en-US.json?url'

export async function fetchIntl(): Promise<IntlShape> {
  // TODO: In the future we will want to fetch other languages, but for now I only know ingles
  const rawMessages = await fetch(enUSMessages)
  // Being super weird, if I await it, then strings don't work, but if I don't, I have an error about syntax in the console.
  // Need to figure out if this will happen when it is deployed
  // This is an issue with how bun has implemented fetch.
  const messages = (await rawMessages.json()) as unknown as Record<
    string,
    MessageFormatElement[]
  >

  return createIntl({
    locale: 'en-US',
    defaultLocale: 'en-US',
    messages: messages,
    onError: (error) => {
      console.warn(`Error creating Intl: ${error.message}`)
    },
  })
}
